import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

import styles from './widgets.module.sass'
import { prefixPlusSignIfLongerThan9Digits } from 'utils/computePhoneNumber'

export const renderContactCard = (person, i18n) => {
	const entries = ['name', 'nif', 'birthday', 'contacts']
	return entries.map((key) => {
		if (person[key]) {
			if (key === 'contacts') {
				return renderContacts(person[key], i18n)
			}
			return (
				<HStack
					key={key}
					className={styles['entry']}
					columns={[1, 3]}
					gap='xsmall'
					justify='space-between'
				>
					<small>
						<strong className='capitalize'>
							{i18n.translate(key)}
						</strong>
					</small>
					<small>{person[key]}</small>
				</HStack>
			)
		}
		return null
	})
}

export const renderContacts = (contacts, i18n) => {
	const entries = ['mobile', 'telephone', 'email']
	return entries.map((key) => {
		if (contacts[key]) {
			const actions = {
				email: `email:${contacts[key]}`,
				telephone: prefixPlusSignIfLongerThan9Digits(contacts[key]),
				mobile: prefixPlusSignIfLongerThan9Digits(contacts[key]),
			}
			return (
				<HStack
					key={key}
					className={styles['entry']}
					columns={[1, 3]}
					gap='xsmall'
					justify='space-between'
				>
					<small>
						<strong className='capitalize'>
							{i18n.translate(key)}
						</strong>
					</small>
					<a href={actions[key]}>
						<small>{contacts[key]}</small>
					</a>
				</HStack>
			)
		}
		return null
	})
}
